import Axios from 'axios'
import { FILES_URL, getErrorMessage } from '@/main'

const state = {}

const getters = {}

const mutations = {}

const actions = {}

export function prepareFilesMetadata(context) {
  Axios.get(`${FILES_URL}/metadata`)
    .then(() => {
      context.commit('setFeatures', { files: { category: 'files' } })
    })
    .catch((error) => {
      console.warn('FILES module is not available: %o', getErrorMessage(error))
      context.commit('removeFeature', { files: {} })
    })
}

export default {
  state,
  getters,
  mutations,
  actions,
}
